<template>
  <label class="text-neutral-80 text-paragraph-3 !font-medium">
    {{ text }}
    <span v-if="required" class="text-alert-error">*</span>
  </label>
</template>

<script setup>
const props = defineProps({ required: Boolean, text: String })
</script>

<style lang="scss" scoped></style>
